import AppLoading from "@/components/elements/AppLoading";
import {mapActions, mapGetters} from "vuex";
import {GlobalService} from "../services/GlobalService";
import moment from 'moment';
import {FileService} from "@/services/FileService";
import {CrewDocumentService} from "@/services/CrewDocumentService";
import crew from "@/views/master_lists/Crew";

export const crewDocumentMixin = {

    data() {
        return {
            compentencyDocs:['NCOC','FL'],
            crewDocument: {
                capacity_rank_id:null
            },
            initialCrewDocumentSelected: {},
            no_doc_no: null,
            no_issued_date: null,
            no_expiry: null,
            no_file:null,
            doc_no:false,
            issued_date:false,
            expiry_date:false,
            crewDocumentHistories: [],
            crewDocumentError: {},
            crewDocumentId: null,
            editable: false,
            newCrewDocument: {
                capacity_rank_id: null,
                reset: false //use for resetting the component
            },
            newCrewDocumentError: {},
            documentTitle: '',
            documentCode: '',
            crewDocumentPath: GlobalService.apiUrl() + '/viewCrewDocument/',
            editableFields: [
                'doc_no', 'issued_date', 'expiry_date', 'watchkeeping_stamp','capacity_rank_id',
                'is_passed', 'attempt'
            ],
            tempUploadedFile: '',
            editFilePrompt: 'NO UPLOADED DOCUMENT',
            docNoRequiredDocs: [
                1,	    // PHILIPPINE SEAMAN BOOK
                14,	    // PANAMA GMDSS SEAMAN'S BOOK
                16,	    // PANAMA SEAMAN BOOK
                18,	    // JAPANESE SEAMAN BOOK
                38,	    // BULGARIAN SEAMAN BOOK
                40,	    // UKRANIAN SEAMAN BOOK
                56,	    // MARSHALL ISLAND SEAMAN BOOK
                105,    // MALAYSIAN SEAMANBOOK
                108,    // LIBERIAN SEAMAN BOOK
                2,	    // PHILIPPINE PASSPORT
                37,	    // CHINESE PASSPORT
                39,	    // BULGARIAN PASSPORT
                41,	    // UKRANIAN PASSPORT
                76,	    // JAPANESE PASSPORT
                106,    // MALAYSIAN PASSPORT
                109,    // LIBERIAN PASSPORT
                71,     // US VISA
                70,     // AUSTRALIAN MARITIME CREW VISA
            ],
            passportDocIds: [
                2,	    // PHILIPPINE PASSPORT
                37,	    // CHINESE PASSPORT
                39,	    // BULGARIAN PASSPORT
                41,	    // UKRANIAN PASSPORT
                76,	    // JAPANESE PASSPORT
                106,    // MALAYSIAN PASSPORT
                109,    // LIBERIAN PASSPORT
            ],
            extensions: [],
            tempSelectedCrewDocument:{},
        }
    },

    components: {AppLoading},

    methods: {
        addExtensionToList() {
            this.extensions.push({
                expiry_date: '',
                issued_date: '',
                id: '',
                document_id: this.crewDocumentId,
                crew_document_id: this.crewDocument.id,
                crew_id: this.crew.id,
            })
        },
        ...mapActions([
            'getCrewDocuments',
            'uploadCrewDocument',
            'getCrewDocumentFile',
            'updateCrewDocument',
            'deleteCrewDocument',
            'getCrewDocumentHistory',
            'updateCrewDocumentFile',
            'deleteCrewDocumentHistory',
            'getCapacityRanks',
            'clearCrewDocuments',
        ]),

        async confirmDeleteCrewDocumentHistory(crewDocumentId, documentId) {
            if (await this.confirmDeleteAlert()) {
                let params = {
                    crewDocumentId: crewDocumentId,
                    documentId: documentId
                }
                if (await this.deleteCrewDocumentHistory(params)) {
                    this.successAlert('Crew Document History Successfully Deleted', 'DELETE');
                    if (this.crewDocument.id === crewDocumentId) {
                        this.crewDocument = Object.assign({}, this.crewDocumentHistory[0]);
                        this.crewDocumentId = this.crewDocument.id;
                        if (this.crewDocumentId) {
                            this.getCrewDocumentFile(this.crewDocumentId);
                        }
                    }
                }
            }
        },

        refreshCrewDocument() {
            this.extensions = [];
            this.crewDocument = {
                capacity_rank_id:null
            };
            this.crewDocumentError = {};
        },

        updateCrewDocumentModal(crewDocument) {
            if(crewDocument.id === 42){
                localStorage.setItem('crewDocument',JSON.stringify(crewDocument));
            }

            this.initialCrewDocumentSelected = crewDocument.crew_document

            this.refreshCrewDocument();
            this.crewDocument = Object.assign({}, crewDocument.crew_document);
            this.crewDocumentId = crewDocument.id;
            this.documentTitle = crewDocument.name;
            this.documentCode = crewDocument.code;
            this.extensions = crewDocument.crew_document.extensions;
            this.issued_date=crewDocument.issued_date;
            this.expiry_date=  crewDocument.expiry_date;
            this.doc_no= crewDocument.doc_no;
            this.no_doc_no=!this.doc_no &&  !this.crewDocument.doc_no;
            this.no_issued_date=!this.issued_date &&  !this.crewDocument.issued_date;
            this.no_expiry=!this.expiry_date &&  !this.crewDocument.expiry_date;


            this.crewDocument.is_passed = crewDocument.crew_document.is_passed
            this.crewDocument.attempt = crewDocument.crew_document.attempt

            this.crewDocument.doc_no=this.doc_no ? crewDocument.crew_document.doc_no : '';
            this.crewDocument.issued_date=this.issued_date ? crewDocument.crew_document.issued_date : '';
            this.crewDocument.expiry_date=this.expiry_date ? crewDocument.crew_document.expiry_date : '';
            this.getCrewDocumentFile(this.crewDocument.id);
            this.getCrewDocumentHistory({crewId: this.crew.id, documentId: this.crewDocumentId});
            this.editable = false;
        },

        getCrewDocumentHistoryRecord(crewDocumentHistory) {
            if (this.crewDocumentId !== crewDocumentHistory.id) {
                this.crewDocument = Object.assign({}, crewDocumentHistory);
                if(this.crewDocument.extensions) {
                    this.extensions=this.crewDocument.extensions;
                }
                else {
                    this.extensions=[]
                }
                this.initialCrewDocumentSelected =  crewDocumentHistory;
                this.getCrewDocumentFile(crewDocumentHistory.id);
            }
        },

        cancelEdit() {
            this.refreshCrewDocument();
            if(this.crewDocumentId===42){
                const crewDoc=JSON.parse(localStorage.getItem('crewDocument'));
                const index = this.crewDocuments.findIndex(crewDocument => crewDocument.id === this.crewDocumentId)
                this.crewDocuments[index]=Object.assign({},crewDoc);
            }
            this.no_doc_no=false;
            this.no_issued_date=false;
            this.no_expiry=false;
            this.updateCrewDocumentModal(this.crewDocuments.find(crewDocument => crewDocument.id === this.crewDocumentId));
            // this.crewDocumentFile = this.tempUploadedFile;
            this.updateCrewDocumentFile(this.tempUploadedFile);
            this.editable = false;

        },

        refreshNewCrewDocument(crewDocument) {
            if (crewDocument) {
                this.newCrewDocument = {
                    crew_id: this.crew.id,
                    document_id: crewDocument.id,
                    capacity_rank_id: null,
                    reset : !this.newCrewDocument.reset,
                 };

                this.documentCode = crewDocument.code;
                this.documentTitle = crewDocument.name;
                this.doc_no=crewDocument.doc_no;
                this.expiry_date=crewDocument.expiry_date;
                this.issued_date=crewDocument.issued_date;
                this.no_doc_no=!this.doc_no;
                this.no_issued_date=!this.issued_date;
                this.no_expiry=!this.expiry_date;
            } else {
                this.newCrewDocument = {crew_id: this.crew.id,capacity_rank_id: null}
            }
            this.newCrewDocumentError = {};
        },

        async confirmUploadCrewCertificate() {
            if (await this.confirmCreateAlert()) {
                let file = document.getElementById('newCrewDocumentFile').files[0];
                let formData = new FormData();
                formData.append('crew_id', this.newCrewDocument.crew_id);
                formData.append('document_id', this.newCrewDocument.document_id);
                formData.append('country_id',this.crew.country.id)
                formData.append('no_expiry', this.no_expiry ? 1 : 0);
                formData.append('no_doc_no', this.no_doc_no ? 1 : 0);
                formData.append('no_issued_date', this.no_issued_date ? 1 : 0);
                formData.append('no_file', this.no_file ? 1 : 0);

                this.editableFields.forEach(key => {
                    let value = this.newCrewDocument[key] ?? ''
                    if (value === '0000-00-00') value = '';
                    formData.append(key, value);
                });

                formData.append('crewFile', file);

                swal.fire({
                    title: "Uploading... Please Wait",
                    allowOutsideClick: false,
                    allowEscapeKey:false,
                    allowEnterKey:false
                });
                swal.showLoading();

                let newCrewDocument = await this.uploadCrewDocument(formData);
                if (newCrewDocument) {
                    if (newCrewDocument.errors) {
                        swal.close();
                        this.newCrewDocumentError = newCrewDocument.errors;
                        this.updateFileFrame();
                    } else {
                        this.successAlert('Crew Document Successfully Uploaded', 'UPLOAD');
                        document.getElementById('newCrewDocumentFile').value = null
                        this.clearIframe();
                        document.getElementById('closeNewCrewDocument').click();

                        this.crewDocument.is_passed = this.newCrewDocument.is_passed
                        this.crewDocument.attempt = this.newCrewDocument.attempt

                    }
                }
            }
        },

        async confirmUpdateCrewDocument() {
            if (this.editable) {
                if (await this.confirmUpdate()) {
                    let formData = new FormData();
                    formData.append('crewDocumentId', this.crewDocument.id);
                    formData.append('no_expiry', this.no_expiry ? 1 : 0);
                    formData.append('no_doc_no', this.no_doc_no ? 1 : 0);
                    formData.append('no_issued_date', this.no_issued_date ? 1 : 0);
                    formData.append('country_id',this.crew.country.id)

                    this.editableFields.forEach(key => {
                        let value = this.crewDocument[key] ?? ''
                        if (value === '0000-00-00') value = '';
                        formData.append(key, value);
                    });

                    let input = document.getElementById('crewDocumentFile');
                    if (input.files && input.files[0]) {
                        let file = input.files[0];
                        formData.append('crewFile', file);
                    }

                    if (this.extensions) {
                        this.extensions.forEach((item,index) => {
                            if (item.expiry_date || item.issued_date) {
                                formData.append('extensions[]', JSON.stringify(item))
                            }
                            let attachment = document.getElementById(`crewExtensionAttachment` + index);
                            if (attachment.files && attachment.files[0]) {
                                let file = attachment.files[0];
                                formData.append(`crewExtensionAttachment` + index, file);
                            }
                        })
                    }

                    swal.fire({
                        title: "Updating... Please Wait",
                        allowOutsideClick: false,
                        allowEscapeKey:false,
                        allowEnterKey:false
                    });
                    swal.showLoading();

                    let updatedCrewDocument = await this.updateCrewDocument(formData);
                    if (updatedCrewDocument) {
                        if (updatedCrewDocument.errors) {
                            swal.close();
                            this.crewDocumentError = updatedCrewDocument.errors;
                        } else {
                            this.successAlert('Crew Document Successfully UPDATED', 'UPDATE');
                            this.updateCrewDocumentModal(updatedCrewDocument);
                            // this.getCrewDocumentFile(this.crewDocument.id);
                            this.updateCrewDocumentFile(this.tempUploadedFile);
                            document.getElementById('newCrewDocumentFile').value = null
                            this.clearIframe();
                            // this.crewDocumentFile = this.tempUploadedFile;
                            this.editable = false;
                        }
                    }
                }
            } else {
                this.tempUploadedFile = this.crewDocumentFile;
                this.editable = true;
            }
        },

        async confirmDeleteCrewDocument(crewDocumentId) {
            if (await this.confirmDeleteAlert()) {
                if (await this.deleteCrewDocument(crewDocumentId)) {
                    this.successAlert('Crew Document Successfully Deleted', 'DELETE');
                }
            }
        },

        updateFileFrame() {
            let input = document.getElementById('newCrewDocumentFile');
            if (input.files && input.files[0]) {
                if (input.files[0].size > 1000000) {
                    document.getElementById('promptSpan').innerText = 'FILE TOO LARGE';
                    this.clearIframe();
                    return;
                } else {
                    document.getElementById('promptSpan').innerText = '';
                    let reader = new FileReader();
                    reader.onload = function (e) {
                        document.getElementById('fileFrame').src = e.target.result + "#zoom=80";
                    };
                    reader.readAsDataURL(input.files[0]);
                }

            } else {
                this.clearIframe();
            }
        },

        async updateViewFileFrame(inputFileId) {
            let input = document.getElementById(inputFileId);
            if (input.files && input.files[0]) {
                if (input.files[0].size > 1000000) {
                    this.editFilePrompt = 'FILE IS TOO LARGE';
                    this.updateCrewDocumentFile('');
                } else {
                    document.getElementById('promptSpan').innerText = '';
                    let reader = new FileReader();
                    let updateCrewDocumentFile = this.updateCrewDocumentFile;
                    reader.onload = await function (e) {
                        updateCrewDocumentFile(e.target.result + "#zoom=80");
                    };
                    reader.readAsDataURL(input.files[0]);
                    this.editFilePrompt = 'NO UPLOADED DOCUMENT';
                }
            } else {
                this.editFilePrompt = 'NO UPLOADED DOCUMENT';
                this.updateCrewDocumentFile('');
            }
        },
        clearIframe() {
            let frame = document.getElementById('fileFrame')
            frame.src = 'about:blank';
        },

        getCrewDocumentUrl(crewDocumentId) {
            let crewDocument = this.crewDocuments.find(document => document.id === this.crewDocumentId)
            return `${this.crewDocumentPath + crewDocumentId}/${crewDocument.code}`
        },

        selectDocuments(source) {
            this.crewDocuments.forEach(document => {
                if (document.crew_document && document.crew_document.hasFile) {
                    if (source.target.checked) {
                        this.printMultipleParams.selectedCrewDocuments.documents.push(document.crew_document.id);
                    } else {
                        this.printMultipleParams.selectedCrewDocuments.documents = this.printMultipleParams.selectedCrewDocuments.documents.filter(documentId => {
                            documentId != document.crew_document.id
                        })
                    }
                }
            });
        },


        updateCrewDocumentExpiry(documentId) {
            if (this.no_expiry){
                this.crewDocument.expiry_date = null;
                this.expiry_date=false;
            } else{
                this.crewDocument.expiry_date = this.crewDocuments
                    .find(document => document.id === documentId)
                    .crew_document
                    .expiry_date;
                    this.expiry_date=true
            }

        },

        updateCrewDocumentIssuedDate(documentId) {
            if (this.no_issued_date) {
                this.crewDocument.issued_date = null;
                this.issued_date=false;
            } else {
                this.crewDocument.issued_date = this.crewDocuments
                    .find(document => document.id === documentId)
                    .crew_document
                    .issued_date;
                this.issued_date=true;
            }
        },

        updateCrewDocumentDocNo(documentId) {
            if (this.no_doc_no) {
                this.crewDocument.doc_no = null;
                this.doc_no=false;
            } else {
                this.crewDocument.doc_no = this.crewDocuments
                    .find(document => document.id === documentId)
                    .crew_document
                    .doc_no;
                    this.doc_no=true;
            }
        },

        clearFileinput(documentFile) {
            document.getElementById(documentFile).value = "";
            // this.crewDocument = {};
            this.updateCrewDocumentFile(this.tempUploadedFile);

        },

        clearNewFile(documentFile){
            this.no_file=!!this.no_file;
            if(this.no_file){
                document.getElementById(documentFile).value = "";
            }

        },

        formatDate(date){
            return date ? moment(new Date(date)).format('D MMM YYYY') : 'N/A';
        },


        async removeExtensionFromList(index) {
            if (this.extensions[index].id) {
                if (await this.confirmDeleteAlert()) {
                    let response = await this.deleteCrewDocument(this.extensions[index].id);
                    if (response) {
                       await this.successAlert('Crew Document Extension Successfully Deleted', 'DELETE');
                       this.$delete(this.extensions, index);
                    }

                }
            } else {
                this.$delete(this.extensions, index);
            }

        },
        async viewExtensionAttachment(crewDocument){
          let file= await CrewDocumentService.getCrewDocumentFile(crewDocument);
          FileService.viewFile(file);
        },
        extractNoOfExtension(crewDocument){
            if(crewDocument != null){
                if(crewDocument.hasOwnProperty('noOfExtensions')){
                    return crewDocument.noOfExtensions ?
                        'with '+crewDocument.noOfExtensions+' extensions' : '';
                }
            }
            else{
                return '';
            }
        },
        toggleNotRequired(param,param2){
            if(this[param]){
                this[param2]=false;
            }
            else {
                this[param2]=true;
            }

        }

    },
    watch: {
        'crewDocument.is_passed'(newValue, oldValue) {
            // This should only be triggered for JAPANESE 3RD GRADE RADIO LICENSE
            if (this.crewDocumentId !== 22) {
                return
            }

            if (oldValue === null || oldValue === undefined) {
                return
            }

            if (newValue) {
                this.crewDocument.attempt = "";
                this.crewDocument.expiry_date = this.initialCrewDocumentSelected.expiry_date ?? ""

                return;
            }

            this.crewDocument.attempt = this.initialCrewDocumentSelected.attempt ?? ""
            this.crewDocument.expiry_date = null
        }
    },
    computed: {
        ...mapGetters([
            'crew',
            'crewDocumentFile',
            'crewDocuments',
            'printMultipleParams',
            'crewDocumentHistory',
            'capacityRanks'
        ]),

        allDocumentSelected() {
            let allSelected = true;
            this.crewDocuments.forEach(document => {
                if (document.crew_document && document.crew_document.hasFile) {
                    if (!this.printMultipleParams.selectedCrewDocuments.documents.includes(document.crew_document.id)) {
                        allSelected = false;
                    }
                }
            });
            return allSelected;
        },


    },

    created() {
    },


    destroyed() {
        this.clearCrewDocuments();
    }


}
